/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Actions_EmptyInputs */



/**
* | output |
* | --- |
* | "Nothing is open." |
*
* @param {Meeting_Prep_Actions_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_actions_empty = /** @type {((inputs?: Meeting_Prep_Actions_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Actions_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Er staat niets open.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Il n'y a rien d'ouvert.")
	return /** @type {LocalizedString} */ ("Nothing is open.")
});